<template>
  <div class="informations-wrapper" v-if="!isUserPending">
    <div class="container">
      <div class="card card-form">
        <div class="card-section">
          <p class="bold">{{ $t("app.profil.informations.editPersonal") }}</p>
          <VForm :callback="() => {}">
            <template #form-body>
              <div class="input-inline">
                <VField name="profil-firstname" rules="required|textOnly" v-model="user.personal_information.first_name" :label="$t('app.form.register.firstName')" :disabled="true" />
                <VField name="profil-lastname" rules="required|textOnly" v-model="user.personal_information.last_name" :label="$t('app.form.register.lastName')" :disabled="true" />
              </div>
              <div class="input-inline">
                <VField type="email" name="profil-mail" rules="required|email" v-model="user.personal_information.email" :label="$t('app.form.email')" :disabled="true" />
              </div>
            </template>
          </VForm>
        </div>
      </div>
      <div class="side-col">
        <div class="card delete-account">
          <p class="bold">{{ $t("app.profil.informations.deleteAccount") }}</p>
          <i18n-t keypath="app.profil.informations.deleteAccountDesc1" tag="p" class="text">
            <template #link>
              <span class="virtual-link" @click="crisp.chat.open()"> {{ $t("app.profil.informations.customerService") }} </span>
            </template>
          </i18n-t>
          <p class="muted text">
            {{ $t("app.profil.informations.deleteAccountDesc2") }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive, inject } from "vue";
import { getImage, getRandomUserPicture } from "@/composables/getImage.js";

import { useImageStore } from "@/stores/image.js";
import { useToast } from "vue-toastification";

import { useOrganisation } from "@/queries/organisation.query";
import { useUpdateProfilePicture, useUser } from "@/queries/user.query";

const toast = useToast();
const { t } = useI18n();

const crisp = inject("crisp");

const { uploadImage } = useImageStore();

const { mutate: updateUserProfilePicture } = useUpdateProfilePicture();

const { data: user, isPending: isUserPending } = useUser();
const { data: organisation, isPending: isOrganisationPending } = useOrganisation();

const image = ref(null);

const state = reactive({
  currentPassword: "",
  newPassword: "",
  confirmPassword: "",
  loading: false,
});

async function setImage(value) {
  state.loading = true;

  const { image_id } = await uploadImage(organisation.value.id, "user_profile_picture", value);

  if (image_id) {
    updateUserProfilePicture(image_id);
  } else {
    toast.error(t("app.profil.informations.imageUploadError"));
  }

  state.loading = false;
}
</script>

<style lang="scss" scoped>
.text {
  font-size: 14px;
}
</style>